import React, { useState, useEffect } from 'react';
import {
  TextField,
  Button,
  Stack,
  Paper,
  Grid
} from '@mui/material';

const AllDataUser = ({ filters, setFilters, applyFilters, clearFilters }) => {
  const [localFilters, setLocalFilters] = useState(filters);

  useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLocalFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleApplyFilters = () => {
    setFilters(localFilters);
    applyFilters(); // Trigger the API call with updated filters
  };

  const handleClearFilters = () => {
    const clearedFilters = {
      username: '',
      email: '',
      createdAt: '',
      sort: 'DESC'
    };
    setLocalFilters(clearedFilters);
    setFilters(clearedFilters);
    clearFilters(); // Trigger the clear API fetch
  };

  return (
    <Paper elevation={2} sx={{ p: 3, mb: 4 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={4}>
          <TextField
            label="Search by Name"
            name="username"
            variant="outlined"
            value={localFilters.username || ''}
            onChange={handleInputChange}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            label="Search by Email"
            name="email"
            variant="outlined"
            value={localFilters.email || ''}
            onChange={handleInputChange}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            label="Creation Date"
            name="createdAt"
            type="date"
            variant="outlined"
            value={localFilters.createdAt || ''}
            onChange={handleInputChange}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Grid>

        <Grid item xs={12}>
          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button variant="contained" color="primary" onClick={handleApplyFilters}>
              Apply
            </Button>
            <Button variant="outlined" color="secondary" onClick={handleClearFilters}>
              Clear
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default AllDataUser;
